const userApps = {
  actions: {
    details: 'View {{name}} details',
    detailsShort: 'Details',
    favorite: 'Favorite {{name}}',
    install: 'Add app',
    installNamed: 'Add {{name}} to My Apps',
    installShort: 'Add',
    remove: 'Remove app',
    removeNamed: 'Remove {{name}}',
    removeShort: 'Remove',
    unfavorite: 'Unfavorite {{name}}',
    use: 'Use app',
  },
  detail: {
    close: 'Close app details',
    instructions: 'Instructions:',
  },
  empty: {
    filtered: 'No matching apps found',
    goMarket: 'Go to App Gallery',
    market: 'No apps are available in the App Gallery',
    mine: 'You have not added any apps from the App Gallery yet',
  },
  emptyDescription: 'No description',
  emptyVersion: 'No version',
  errors: {
    forbidden: 'This account does not have permission to access these apps.',
    channelUnavailable: 'This app is not available on the current channel.',
    listDescription: 'The app list is unavailable. Try again later.',
    listTitle: 'Unable to load apps',
    operationDescription: 'The operation could not be completed. Try again later.',
    operationTitle: 'Operation failed',
    unauthorized: 'Your session has expired. Please sign in again.',
  },
  filters: {
    all: 'All',
  },
  feedback: {
    favoriteSuccess: 'App favorited',
    installSuccess: 'Added to My Apps',
    removeSuccess: 'App removed',
    unfavoriteSuccess: 'Favorite removed',
  },
  loading: 'Loading apps',
  moreTags: '...',
  removeConfirm: {
    cancel: 'Cancel',
    close: 'Close removal confirmation',
    confirm: 'Remove',
    description: 'Remove {{name}} from My Apps? You can add it again from the App Gallery later.',
    title: 'Remove app',
  },
  search: {
    label: 'Search apps',
    placeholder: 'Search apps',
    placeholderMobile: 'Search apps by name',
  },
  tabs: {
    market: 'App Gallery',
    mine: 'My Apps',
  },
}

export default userApps
